import React from "react";
import Routes from "./Routes";
import { AuthProvider } from "./contexts/AuthContext";
import { ErrorProvider } from "./contexts/ErrorContext";
import ErrorNotification from "./components/ui/ErrorNotification";

function App() {
  return (
    <ErrorProvider>
      <AuthProvider>
        <ErrorNotification />
        <Routes />
      </AuthProvider>
    </ErrorProvider>
  );
}

export default App;
